export default __webpack_public_path__ + "static/media/zero.b9137e9d.png";